import BundleActivityDetails from './BundleActivityDetails';

export default BundleActivityDetails;
